module.exports = __webpack_public_path__ + "static/media/variable-names-logo-icon.898e252b.png";